import {StringUtils} from "./string-utils";

export class ObjectUtils {
  static isNil<T>(o: T) {
    return o === undefined || o === null;
  }

  static isNotNil<T>(o: T) {
    return !ObjectUtils.isNil(o);
  }

  static cloneDeep<T>(o: T) {
    return this.isNil(o) ? o : JSON.parse(JSON.stringify(o)) as T;
  }

  static isNilOrEmptyObject(data: unknown): boolean {
    return this.isNil(data) || this.isEmptyObject(data);
  }

  static isNotNilAndNotEmptyObject(data: unknown): boolean {
    return !this.isNilOrEmptyObject(data);
  }

  static isEmptyObject(data: unknown): boolean {
    return JSON.stringify(data) === JSON.stringify({});
  }

  static isDeeplyEmptyObject(data: object): boolean {
    return !Object.values(data).some(v => ObjectUtils.isNotNil(v) && !StringUtils.isBlankOrNull(typeof v === 'object' ? v : v.toString()))
  }

  /**
   * check recursively if an object is fully filled (no null value or undefined or empty string
   * @param obj
   */
  static isValidObject(obj: any): boolean {
    for (let propName in obj) {
      if( typeof obj[propName] === "object" ) {
        if(!this.isValidObject(obj[propName]) || obj[propName] === null || obj[propName].length === 0 )
        {
          return false;
        }
      }
      else if (
        obj[propName] === null      ||
        obj[propName] === undefined ||
        obj[propName] === ''
      ) {
        return false;
      }
    }
    return !!obj;
  }

  static hasAtLeastOneTruthyData(data: boolean[]): boolean {
    return data.some(d => d);
  }

  static hasAllTruthyData(data: boolean[]): boolean {
    return !data.some(d => !d);
  }


}
